type OMITTED_VALUES = 'createdAt' | 'updatedAt' | 'organisation' | 'creator';

export interface OrganisationRef {
  id: string;
  displayName: string;
}

export interface CreatorRef {
  id: string;
  firstName: string;
  lastName: string;
  email: string;
}

export interface FormModel {
  id: string;
  organisation_id?: string;
  identifier: string;
  name: string;
  description?: string;
  version: number;
  formData?: any; // JSON data
  isActive: boolean;
  isTemplate: boolean;
  createdBy?: string;
  status: string; // DRAFT, PUBLISHED, ARCHIVED

  createdAt: string;
  updatedAt: string;

  organisation?: OrganisationRef;
  creator?: CreatorRef;
}

export interface FormPageModel {
  data: FormModel[];
  total: number;
  page: number;
  limit: number;
}

export const EMPTY_FORM_PAGE_MODEL: FormPageModel = {
  data: [],
  total: 0,
  page: 1,
  limit: 10,
};

export interface CreateFormModel extends Omit<FormModel, 'id' | 'version' | 'identifier' | OMITTED_VALUES> {
  version?: number; // Optional for create, will default to 1 if not provided
  identifier?: string; // Optional - will be auto-generated if not provided
}

export interface UpdateFormModel extends Partial<Omit<FormModel, 'id' | 'identifier' | 'version' | OMITTED_VALUES>> {}

export const FORM_STATUSES = ['DRAFT', 'PUBLISHED', 'ARCHIVED'] as const;
export type FormStatus = (typeof FORM_STATUSES)[number];
